module.exports = __webpack_public_path__ + "static/apple-icon-152x152-0a316604563b3cb5007c161f6cd6f629.png";